import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCog } from "@fortawesome/free-solid-svg-icons"

function NavBar(props){
    return(
        <div className="navBar" role="banner">
            <a href="#">
                <FontAwesomeIcon icon={faCog} />
            </a>
            <div className="border"></div>
            <a className="category" href="https://platform.wildsky.dev">Arcade</a>
            <a className="category active" href="/">Modules</a>
            <a className="category" href="https://forum.wildsky.dev">Forum</a>
        </div>
    )
}

export default NavBar